import React from "react";
import Link from "next/link";
import { Application } from "../utils/model";
import Thumbnail from "/global-layout/global-components/thumbnail";

var md5 = require("md5");

export interface iProps {
  app: Application;
  category?: string;
  parent_category?: string;
  subcategory?: string;
  platform?: string;
  classes?: string;
  maxWidth?: string;
  maxChar?: number;
}

const ApplicationListItemWithExcerpt = (props: iProps) => {
  const app = props.app;
  if (!app) {
    return;
  }

  let imagePath = app.icon ? app.icon.url : "";

  return (
    <Link
      className={`text-black desktopListitem cursor-pointer transform transition hover:scale-105 p-1 rounded-2xl ${props.classes}`}
      href={`/${app.platform?.name?.toLowerCase()}/${props.parent_category}/${
        app.subcategory?.slug
      }/${props.app.slug}`}
      title={app.title}
    >
      <div className="shadow-md border border-slate-200 h-full flex flex-col p-4 rounded-xl bg-white">
        <div className="flex flex-row align-middle items-center">
          <div className="thumbnail max-w-[64px] max-h-[64px] bg-white flex overflow-hidden justify-center items-center aspect-square relative w-full rounded-xl text-center ">
            <Thumbnail
              appName={app.title}
              imagePath={imagePath}
              classes="max-w-[54px] max-h-[54px]"
              index={app.id}
            />
          </div>
          <div className="title text-md md:text-md text-left text-ellipsis overflow-hidden ml-1">
            {app.title &&
            app.title.length > (props.maxChar ? props.maxChar : 40)
              ? `${app.title.substring(
                  0,
                  props.maxChar ? props.maxChar : 40
                )}...`
              : app.title}
          </div>
        </div>
        <div className="mt-2 text-sm md:text-sm text-left text-ellipsis overflow-hidden">
          {app.excerpt && app.excerpt.length > 90
            ? app.excerpt.substring(0, 90) + "..."
            : app.excerpt}
        </div>
      </div>
    </Link>
  );
};

export default ApplicationListItemWithExcerpt;
